import { Component, Prop, Vue } from 'vue-property-decorator';
import { itiMessageService, itiSignalRService } from '@/iti-core-vue';
import NotificacionCard from '@/components/notificacion_card/notificacion_card.vue';
import { Notification } from '@/shared/dtos/notificacion';
import ListaNotificacionesModule from '@/store/modules/listaNotificaciones.module';
import NotificationCounterModule from '@/store/modules/contadorNotificaciones.module';
@Component({
    components: {
        NotificacionCard,
    },
})
export default class Notificaciones extends Vue {
    public get notificaciones(){
        return ListaNotificacionesModule.notificaciones;
    }

    public get notificacionesNoLeidas(){
        return ListaNotificacionesModule.notificaciones.filter((val, index, array) => {
            return !val.isRead && (val.sourceUser!=-2 || this.esUltimaNotificacionSala(val, array) )
        } ).sort((a,b) =>{
            return a.creationDate.valueOf() - b.creationDate.valueOf();
        });
    }

    private esUltimaNotificacionSala(notificacion: Notification, array: Notification[]): boolean{
        if(!array.find(x => !x.isRead && x.idEventSource == notificacion.idEventSource && x.creationDate > notificacion.creationDate))
            return true;
        else 
            return false;
    }

    public get notificacionesLeidas(){
        return ListaNotificacionesModule.notificaciones.filter((val, index, array) => val.isRead).sort((a,b) =>{
            return a.creationDate.valueOf() - b.creationDate.valueOf();
        });
    }

    public async created(){
        await ListaNotificacionesModule.cargarNotificaciones();
        itiSignalRService.listenFor('receiveNotification', this.receiveNotification);
    }

    public marcarLeido(){
        this.notificacionesNoLeidas.forEach((value, index, array) => {
        ListaNotificacionesModule.markNotificationAsRead(value.id);
        value.isRead = true;
        NotificationCounterModule.decrementCounter();
        })
    }
    public marcarSalaLeido(id: any){
        this.notificaciones.forEach((value, index, array) => {
            if(!value.isRead && value.idEventSource === id){
                ListaNotificacionesModule.markNotificationAsRead(value.id);
                value.isRead = true;
                NotificationCounterModule.decrementCounter();
            }
        })
    }
    
    public destroyed(){
        itiSignalRService.unListenFor('receiveNotification', this.receiveNotification);
    }
    public receiveNotification(notification: Notification){
    }
}
